// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2rN40","copyright":"Footer_copyright__3AjZk"};